import { IconGitBranch } from '@developerz/ui';
import type { JSX } from 'solid-js';
import { t } from '../i18n';
import { GH_APP_INSTALL_URL } from '../lib/onboarding';
import { FinishSetupCta } from './FinishSetupCta';
import { buttonClass } from './ui/Button';

// The rail's two CTAs, both non-admin-host (split out of `AppSidebar`, which sits
// at biome's 120-line function budget). `<FinishSetupCta/>` is the way BACK into
// the setup funnel and renders only while onboarding is unfinished, so it is never
// the dead end #323 objected to; every other door out of the wizard was one-way.
// Install-on-more-repos goes to the GitHub App page directly — correct mid-funnel
// AND once complete. External URL → plain <a>, not the router <A>.
//
// In the collapsed icon rail (#7710) both become icon-only: the words sit in
// `.app-sidebar__cta-text`, visually hidden there and never removed, so each link
// keeps its name, and `data-rail-tip` shows them beside the icon.
export function SidebarCtas(props: { readonly resolve: (href: string) => string }): JSX.Element {
  return (
    <>
      <FinishSetupCta resolve={props.resolve} />
      <a
        class={`${buttonClass({ variant: 'outline' })} app-sidebar__cta`}
        href={GH_APP_INSTALL_URL}
        target="_blank"
        rel="noreferrer"
        data-rail-tip={t('nav.install')}
      >
        <IconGitBranch size="1rem" />
        <span class="app-sidebar__cta-text">{t('nav.install')}</span>
      </a>
    </>
  );
}
